/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { customInstance } from '../../mutator'
import type { HTTPValidationError } from '../fastAPI.schemas'

/**
 * @summary Download File
 */
export const downloadFile = (
  projectGuid: string,
  rootFolderGuid: string,
  fileGuid: string,
  signal?: AbortSignal,
) => {
  return customInstance<Blob>({
    url: `/projects/${projectGuid}/download/files/${rootFolderGuid}/${fileGuid}`,
    method: 'GET',
    responseType: 'blob',
    signal,
  })
}

export const getDownloadFileQueryKey = (
  projectGuid?: string,
  rootFolderGuid?: string,
  fileGuid?: string,
) => {
  return [`/projects/${projectGuid}/download/files/${rootFolderGuid}/${fileGuid}`] as const
}

export const getDownloadFileQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  rootFolderGuid: string,
  fileGuid: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getDownloadFileQueryKey(projectGuid, rootFolderGuid, fileGuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadFile>>> = ({ signal }) =>
    downloadFile(projectGuid, rootFolderGuid, fileGuid, signal)

  return {
    queryKey,
    queryFn,
    enabled: !!(projectGuid && rootFolderGuid && fileGuid),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData> & {
    queryKey: QueryKey
  }
}

export type DownloadFileQueryResult = NonNullable<Awaited<ReturnType<typeof downloadFile>>>
export type DownloadFileQueryError = HTTPValidationError

/**
 * @summary Download File
 */

export function useDownloadFile<
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  rootFolderGuid: string,
  fileGuid: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadFileQueryOptions(projectGuid, rootFolderGuid, fileGuid, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}
